export enum CorporateClientStatuses {
  Deactivated = 0,
  ComingSoon = 5,
  Active = 10,
}
